module.exports = __webpack_public_path__ + "static/media/post-img7.d4e0fad3.jpg";